import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import { Form } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import AsyncCreatable from "react-select/async-creatable";
import _ from "lodash";
import "whatwg-fetch";

var ReactSelectWidget = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ReactSelectWidget, _Component);

  function ReactSelectWidget(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      if (!e) return false;
      var value = undefined;

      if (e && (_this.props.options.isMulti || _this.props.schema.type === "array")) {
        value = Array.from(e, function (item) {
          return item.value;
        });

        _this.props.onChange(value);
      } else if (e) {
        value = e.value;

        _this.props.onChange(value);
      }

      _this.setState({
        value: e
      }); // The value always needs to be in this format: {value: value, label: label}


      return true;
    });

    _this.state = _extends({}, props, {
      value: Array.isArray(props.value) ? _this._transformArraytoLabelsAndValues() : props.value ? {
        value: props.value,
        label: props.value
      } : null,
      inputValue: props.value,
      select_options: []
    });
    return _this;
  }

  var _proto = ReactSelectWidget.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var remote_options = this.props.options.remote;

    if (remote_options && remote_options.url) {
      setTimeout(function () {
        return _this2._setRemoteSelectOptions();
      }, 10);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value && this.props.options.remote) {
      var value = this.state.value;

      if (value && Array.isArray(value)) {
        value = this._setLabelsArrayValues();
      }

      this.setState({
        value: value
      });
    }
  };

  _proto._setRemoteSelectOptions = function _setRemoteSelectOptions() {
    var _this3 = this;

    var remote_request = this.getRemoteData();
    var remote_options = this.props.options.remote;
    remote_request.then(function (response) {
      if (response.status === 200) {
        response.json().then(function (remoteData) {
          var record_keys = remote_options.paths && remote_options.paths.record || [];
          if (record_keys) record_keys.map(function (key, i) {
            remoteData = remoteData[key];
          }); // This traverses the list of path names from the record array in the paths object.

          var select_options = Array.isArray(remoteData) ? remoteData.map(function (item, index) {
            if (remote_options.paths) {
              var _value = Object.assign({}, item);

              var label = Object.assign({}, item);
              remote_options.paths.value.map(function (key, i) {
                _value = _value[key];
              });
              remote_options.paths.label.map(function (key, i) {
                label = label[key];
              });
              return {
                value: _value,
                label: label
              };
            } else {
              return item[Object.keys(remoteData)[0]];
            }
          }) : [];
          if (!select_options.length) console.warn("ReactSelectWidget: There's no options being generated from the remote data. Check that paths were set properly. ");
          var value = _this3.state.value;

          if (value && Array.isArray(value)) {
            value = _this3._setLabelsArrayValues(select_options);
          } else if (value) {
            var option = select_options.find(function (option) {
              return option.value === value.value;
            });
            value = option;
          }

          _this3.setState({
            select_options: select_options,
            value: value
          });
        });
      }
    });
  };

  _proto._transformArraytoLabelsAndValues = function _transformArraytoLabelsAndValues() {
    if (this.props.value == undefined) return [];
    return this.props.value.map(function (val, i) {
      return {
        value: val,
        label: val
      };
    });
  };

  _proto._setLabelsArrayValues = function _setLabelsArrayValues(select_options) {
    if (select_options === void 0) {
      select_options = null;
    }

    if (!select_options) select_options = this.state.select_options;

    var value = this._transformArraytoLabelsAndValues();

    return value.map(function (obj) {
      var option = select_options.find(function (_ref) {
        var value = _ref.value;
        return value === obj.value;
      });
      return {
        value: obj.value,
        label: option ? option.label : obj.value
      };
    });
  };

  _proto.entriesDataTransform = function entriesDataTransform() {
    var data = [];

    if (this.props.options.remote && this.props.options.remote.url) {
      data = this.state.select_options;
    } else if (this.props.schema["enum"] || this.props.schema.items && this.props.schema.items["enum"]) {
      var enumValues = this.props.schema["enum"] || this.props.schema.items["enum"];
      var enumNames = this.props.schema.enumNames;
      data = enumValues.map(function (item, index) {
        var label = item;
        if (enumNames && enumValues.length === enumNames.length) label = enumNames[index];
        var obj = {
          value: item,
          label: label
        };
        return obj;
      });
    }

    return data;
  };

  _proto.getRemoteData = /*#__PURE__*/function () {
    var _getRemoteData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(this.state.options.remote.url, {
                method: this.state.options.remote.method || "GET",
                headers: _extends({
                  Accept: "application/json",
                  "Content-Type": "application/json"
                }, this.state.options.remote.headers)
              });

            case 2:
              response = _context.sent;
              _context.next = 5;
              return response;

            case 5:
              return _context.abrupt("return", _context.sent);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getRemoteData() {
      return _getRemoteData.apply(this, arguments);
    }

    return getRemoteData;
  }();

  _proto.getData = function getData() {
    var data = this.entriesDataTransform();

    var filteredData = function filteredData(value) {
      return data.filter(function (item) {
        return item.label.toLowerCase().includes(value.toLowerCase());
      });
    };

    var options = function options(value) {
      return new Promise(function (resolve) {
        setTimeout(function () {
          return resolve(filteredData(value));
        }, 200);
      });
    };

    return options;
  };

  _proto.render = function render() {
    var _this4 = this;

    var _this$props$options = this.props.options,
        isClearable = _this$props$options.isClearable,
        isSearchable = _this$props$options.isSearchable,
        isCreateable = _this$props$options.isCreateable;
    var isMulti = this.props.options.isMulti || this.props.schema.type === "array" || false;

    var isList = _.get(this.props, "options.isList", false);

    var _$get = _.get(this.props, "schema", {}),
        title = _$get.title;

    if (isCreateable) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Label, null, title), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AsyncCreatable, {
        classNamePrefix: "react-select",
        className: isList ? "is-list" : "",
        selectProps: {
          className: isList ? "is-list-input" : ""
        },
        cacheOptions: true,
        defaultOptions: this.state.select_options.length ? this.state.select_options : true,
        loadOptions: this.getData(),
        onChange: this.onChange,
        isClearable: isClearable,
        isMulti: isMulti,
        isSearchable: isSearchable,
        value: this.state.value,
        isDisabled: this.state.disabled || this.state.readonly
      }), /*#__PURE__*/React.createElement("input", {
        name: this.props.id,
        id: this.props.id,
        style: {
          position: "absolute",
          border: 0,
          width: 1,
          height: 1
        },
        type: "text",
        onChange: function onChange(event) {
          return _this4.state.value;
        },
        required: this.props.required,
        value: this.state.value || ""
      })));
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Label, null, title), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AsyncSelect, {
        classNamePrefix: "react-select",
        className: isList ? "is-list" : "",
        cacheOptions: true,
        selectProps: {
          className: isList ? "is-list-input" : ""
        },
        defaultOptions: this.state.select_options.length ? this.state.select_options : true,
        loadOptions: this.getData(),
        onChange: this.onChange,
        isClearable: isClearable,
        isMulti: isMulti,
        isSearchable: isSearchable,
        value: this.state.value,
        isDisabled: this.state.disabled || this.state.readonly
      }), /*#__PURE__*/React.createElement("input", {
        name: this.props.id,
        id: this.props.id,
        style: {
          position: "absolute",
          border: 0,
          width: 1,
          height: 1
        },
        type: "text",
        onChange: function onChange(event) {
          return _this4.state.value;
        },
        required: this.props.required,
        value: this.state.value || ""
      })));
    }
  };

  return ReactSelectWidget;
}(Component);

export default ReactSelectWidget;